<script lang="ts">
  /** 判定の記号（色だけに頼らない。必ず文字と並べる）。読み上げない。 */
  interface Props {
    kind: 'ok' | 'warn' | 'over' | 'diff';
  }

  let { kind }: Props = $props();
</script>

<svg class="state-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
  {#if kind === 'ok'}
    <path
      d="M4 10.5l4 4 8-9"
      fill="none"
      stroke="currentColor"
      stroke-width="2.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  {:else if kind === 'diff'}
    <path
      d="M4 7h12M4 13h12M13 4l-6 12"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  {:else if kind === 'warn'}
    <circle cx="10" cy="10" r="7.5" fill="none" stroke="currentColor" stroke-width="2" />
    <path d="M10 6v5M10 13.5v.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  {:else}
    <path
      d="M10 3l8 14H2z"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path d="M10 8v4M10 14.5v.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  {/if}
</svg>

<style>
  .state-icon {
    width: 1.1em;
    height: 1.1em;
    flex: none;
  }
</style>
